const fromDtoToStylist = (item) =>
  item
    ? {
        userName: item.user_name,
        firstName: item.first_name,
        lastName: item.last_name,
        gender: item.gender,
        image: item.image,
        title: item.title,
        id: item.id,
        salonId: item.salon_id,
        status: item.status,
        role: item.role,
        categories: item.categories,
        servesAsWaitlist: item.serves_as_waitlist,
        isSelfEmployed: item.is_self_employed,
        permissionLevel: item.permission_level,
        hasColumn: item.has_column,
        hasRemoteLogin: item.has_remote_login,
        hasPinLogin: item.has_pin_login,
        hasCalSync: item.has_cal_sync,
        userId: item.user_id,
        email: item.email,
        phone: item.phone,
      }
    : item;

export default fromDtoToStylist;
